<div class="title-group">
	<div class="title-div">
		<img class="title-div-img" [src]="SelectedImageLibraryItem.ImageLibraryData_Thumb" />
	</div>

	<div class="title-div" style="margin-top: 5px">
		<label>{{ SelectedImageLibraryItem.ImageLibraryItemName }}</label>
	</div>
</div>

<div class="rename-group">
	<!--			   -->
	<!-- Image Name  -->
	<!-- 			   -->
	<div class="rename-group-item">
		<div class="rename-group-item-div1">
			<label>Image Name</label>
		</div>

		<div style="width: 300px">
			<input type="text" class="form-control" name="ImageName" [(ngModel)]="NewImageLibraryItemName" />
		</div>
	</div>

	<!--				-->
	<!-- Error Message  -->
	<!--				-->
	<div class="rename-group-item" [style.display]="ErrorMessage != '' ? 'block' : 'none'">
		<div>
			<label class="error-message">{{ ErrorMessage }}</label>
		</div>
	</div>
</div>

<!-- 		 -->
<!-- Buttons -->
<!-- 		 -->
<div style="margin-top: 20px">
	<button class="btn btn-primary" style="margin-left: 0px" [disabled]="isBusy == true" (click)="onRename()">Ok</button>
	<button class="btn btn-primary" style="margin-left: 5px" (click)="onClose()">Cancel</button>
</div>
